
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Artboard","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M100 172c-39.701 0-72-32.385-72-72.19A71.876 71.876 0 0135.899 67c-4.215 20.858 1.718 43.384 17.817 59.527 12.761 12.795 29.523 19.19 46.284 19.19 16.764 0 33.526-6.395 46.286-19.19 16.099-16.141 22.03-38.665 17.82-59.52A71.884 71.884 0 01172 99.81c0 39.805-32.299 72.19-72 72.19zm13.547-138c7.298 0 14.018 2.44 19.453 6.505-14.322.042-25.963 11.684-25.963 25.996 0 14.31 11.641 25.952 25.963 25.994C127.565 96.56 120.845 99 113.547 99 95.6 99 81 84.42 81 66.5S95.6 34 113.547 34zm32.386 34.328C145.266 74.874 139.721 80 133.001 80 125.832 80 120 74.168 120 67s5.832-13 13-13c6.721 0 12.266 5.125 12.933 11.673.019.444.067.88.067 1.328 0 .447-.048.884-.067 1.327zm-8.45 49.324C127.578 127.549 114.41 133 100.407 133c-14.007 0-27.175-5.451-37.075-15.348-20.444-20.43-20.444-53.67 0-74.1C69.97 36.916 78.095 32.334 86.938 30 75.732 38.366 68.43 51.684 68.43 66.708c0 25.28 20.581 45.847 45.878 45.847 15.01 0 28.317-7.273 36.692-18.44-2.29 8.624-6.765 16.785-13.52 23.537h.002zM103.334 15.084a66.404 66.404 0 00-3.332-.084H100l-.053.001c-1.097 0-2.189.029-3.275.083C51.342 16.841 15 54.246 15 100.001 15 146.87 53.132 185 100 185s85-38.13 85-85c0-45.75-36.339-83.156-81.665-84.916z","id":"Fill-1","fill":"#1A1919"}})])])
          )
        }
      }
    